import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Inject Tailwind CSS for immediate premium styling
const tailwindScript = document.createElement('script');
tailwindScript.src = "https://cdn.tailwindcss.com";
document.head.appendChild(tailwindScript);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
